import { Grid } from '@mui/material'
import React, { createContext, useEffect, useState } from 'react'
import AddEditForm from './AddEditForm'
import { WhatsappEnumServices } from './service';
import WhatsappEnumList from './EnumList';
import { NotificationServices } from '../../notification_new/NotificationServices';

const WhatsappEnumDataContext = createContext();

const WhatsappEnum = () => {
    const whatsappEnumInitialData = {
        title:'',
        body:'',
        type:'WHATSAPP',
        notificationEnum:'',
        whatsappTemplate:'',
        headerMedia:'',
    }
    const [whatsappEnumData, setWhatsappEnumData] = useState(whatsappEnumInitialData);

    const [paginationModel,setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
        filters: {
            // searchKey: "",
            sortBy:'updatedAt',
            sortType:'desc',
            filterOptions: []
        }
    })
    const [whatsappEnumList, setWhatsappEnumList] = useState([]);
    const [totalRowCount,setTotalRowCount] = useState(0);
    const [loadingList,setLoadingList] = useState(false)

    const fetchWhatsappEnumist = async() => {
        setLoadingList(true);
        try{
            const response = await WhatsappEnumServices.fetchWhatsappEnumList(paginationModel);
            console.log('urban type list fetching response :',response);

            if(response.success == '1'){
                setWhatsappEnumList(response.data.list)
                setTotalRowCount(response.data.totalItems)
            }else if (response.success == '0'){
                console.log("error :",response?.message)
            }
        }catch (error){
            console.log("error:",error)
        }finally{
            setLoadingList(false)
        }
        
    }

    const [selectedWhatsappEnumData, setSelectedWhatsappEnumData] = useState(null);
    const [whatsappTemplateList, setWhatsappTemplateList] = useState([]);
    const fetchWhatsappTemplateList = async() => {
        try{
            const response = await NotificationServices.fetchWhatsAppTemplates();
            if(response.success == '1' && response.data){
                setWhatsappTemplateList(response.data);
            }else if (response.success == '0'){
                console.log("error :",response?.message)
            }
        }catch (error){
            console.log("error:",error)
        }
    }
    useEffect(()=>{
        fetchWhatsappTemplateList();
    },[])
  return (
    <WhatsappEnumDataContext.Provider value={{whatsappEnumInitialData,whatsappEnumData,setWhatsappEnumData,fetchWhatsappEnumist,whatsappEnumList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedWhatsappEnumData, setSelectedWhatsappEnumData,whatsappTemplateList}}>
        <Grid container spacing={1}>            
            <Grid item xs={12} lg={4}>
                <AddEditForm/>
            </Grid>
            {/* <PermissionGuard feature="gst" permission="canView"> */}
                <Grid item xs={12} lg={8}>
                    <WhatsappEnumList/>
                </Grid>
            {/* </PermissionGuard> */}
        </Grid>
    </WhatsappEnumDataContext.Provider>
  )
}

export default WhatsappEnum
export { WhatsappEnumDataContext };
